<template class="action-bar-template">
  <div class="dashboard-action-bar" data-cy="dashboard-action-bar" @mouseover="mouseoverHandler">
    <template v-if="!hideActionButtons">
      <kw-button
        v-if="!getViewkeyView && !isViewOnlyUser"
        id="multi-edit-button"
        button-type="text"
        prepend-icon-class="kw kw-edit"
        class="button-action-bar"
        data-cy="dashboard-edit-button"
        :disabled="isDisable"
        @click.stop="emitEdit"
        @prepend-icon-mouseover="getTooltip($event, 'edit')"
      />
      <kw-button
        v-if="isSearch"
        class="button-action-bar"
        button-type="text"
        :disabled="true"
        prepend-icon-class="kw kw-tag"
        data-cy="manage-keywords-tags-button"
        @prepend-icon-mouseover="getTooltip($event, 'footer-action-restricted-on-search')"
      />
      <template v-else>
        <manage-tags v-if="!getViewkeyView && !isViewOnlyUser" :disabled="isDisable || isSearch" />
      </template>
      <kw-button
        v-if="!isViewOnlyUser && !getViewkeyView && !getGlobalSearchQuery"
        class="button-action-bar"
        :disabled="isDisable || getIsRefreshRunning || !this.getPermissionData('on_demand_updates')"
        button-type="text"
        prepend-icon-class="kw kw-refresh-update"
        data-cy="refresh-keywords-button"
        @click="handleRefreshKeywords"
        @prepend-icon-mouseover="getTooltip($event, null, refreshTooltip, 170)"
      >
        <div v-if="getIsRefreshRunning" slot="contentSlot">
          <span @mouseover="getTooltip($event, 'refreshing-kw')">
            <loader color="0074D9" />
          </span>
        </div>
      </kw-button>
      <div>
        <kw-button
          class="button-action-bar"
          button-type="text"
          :disabled="isSearch || isDisable"
          prepend-icon-class="kw kw-charts"
          data-cy="show-keywords-chart-button"
          @click="toggleCommonKeywordsCharts"
          @prepend-icon-mouseover="getChartTooltip($event)"
        />
      </div>
      <kw-button
        v-if="!isViewOnlyUser"
        class="button-action-bar"
        button-type="text"
        :disabled="isDisable"
        prepend-icon-class="kw kw-download"
        data-cy="export-keywords-button"
        @click="exportSelectedAsTXT"
        @prepend-icon-mouseover="getTooltip($event, 'export-keywords')"
      />
      <kw-button
        v-if="!isViewOnlyUser && !getViewkeyView"
        class="button-action-bar"
        button-type="text"
        :disabled="isDisable"
        prepend-icon-class="kw kw-edit-3"
        data-cy="move-keywords-button"
        @click.stop="emitMove"
        @prepend-icon-mouseover="getTooltip($event, 'move-keywords')"
      />
      <template v-if="!getViewkeyView && !isViewOnlyUser">
        <kw-button
          class="button-action-bar"
          button-type="text"
          :disabled="isDisable"
          prepend-icon-class="kw kw-trash-2"
          data-cy="delete-keywords-button"
          @click="openDeleteKeywordsModal"
          @prepend-icon-mouseover="getTooltip($event, 'delete')"
        />
      </template>
      <kw-button
        v-if="!getViewkeyView && !isViewOnlyUser"
        class="button-action-bar"
        button-type="text"
        :disabled="isDisable"
        prepend-icon-class="kw kw-copy"
        data-cy="duplicate-keywords-button"
        @click.stop="duplicateKeywords"
        @prepend-icon-mouseover="getTooltip($event, 'duplicate-keywords')"
      />
      <template v-if="!getViewkeyView && !isViewOnlyUser">
        <div v-if="getStarsStatuses.addStartVisible">
          <kw-button
            class="button-action-bar"
            data-cy="iconsstar"
            button-type="text"
            :disabled="isSearch || isDisable"
            prepend-icon-class="kw kw-iconsstar"
            @click="addToFavorite"
            @prepend-icon-mouseover="getFavoriteTooltip($event, 'set-fav')"
          />
        </div>
        <div v-if="getStarsStatuses.removeStartVisible">
          <kw-button
            class="button-action-bar"
            button-type="text"
            :disabled="isSearch || isDisable"
            prepend-icon-class="kw kw-remove-star"
            data-cy="remove-iconsstar"
            @click="removeFromFavorite"
            @prepend-icon-mouseover="getFavoriteTooltip($event, 'remove-fav')"
          />
        </div>
      </template>

      <template v-if="!isSearch && !isMobile">
        <div v-if="isSelectAllVisible" class="select_all_block">
          <template v-if="!keyKeywordsById.length">
            {{
              $t('other-pages-selected-keywords', {
                count: getSelectedAuth.length,
              })
            }}
            <span @click="handleSelectAll">{{
              $t('select-all-count-keywords', {
                count: getTotalKeywords,
              })
            }}</span>
          </template>
          <template v-else-if="getSelectedAuth.length === getOriginalItems.length">
            {{
              $t('one-pages-selected-keywords', {
                count: keyKeywordsById.length,
              })
            }}
            <span @click="handleSelectAll">{{
              $t('select-all-count-keywords', {
                count: getTotalKeywords,
              })
            }}</span>
          </template>
          <template v-else>
            {{
              $t('selected-keywords-count', {
                count: getSelectedAuth.length,
              })
            }}
            <span @click="handleSelectAll">{{
              $t('select-all-count-keywords', {
                count: getTotalKeywords,
              })
            }}</span>
          </template>
        </div>
        <div v-if="getIsAllCheckboxesSelected && !getAllWithoutIdsData.length" class="select_all_block">
          {{ $t('all-keywords-are-selected', { count: getTotalKeywords }) }}
          <span @click="handleUnSelectAll">{{ $t('unselect-all') }}</span>
        </div>
        <div v-if="getIsAllCheckboxesSelected && getAllWithoutIdsData.length" class="select_all_block">
          <template v-if="isCurrentPageUnselected">
            {{
              $t('other-pages-selected-keywords', {
                count: getTotalKeywords - getAllWithoutIdsData.length,
              })
            }}
            <span @click="handleSelectAll">{{
              $t('select-all-count-keywords', {
                count: getTotalKeywords,
              })
            }}</span>
          </template>
          <template v-else-if="isOnlyCurrentPageItemsSelected">
            {{
              $t('one-pages-selected-keywords', {
                count: getTotalKeywords - getAllWithoutIdsData.length,
              })
            }}
            <span @click="handleSelectAll">{{
              $t('select-all-count-keywords', {
                count: getTotalKeywords,
              })
            }}</span>
          </template>
          <template v-else>
            {{
              $t('selected-keywords-count', {
                count: getTotalKeywords - getAllWithoutIdsData.length,
              })
            }}
            <span @click="handleSelectAll">{{
              $t('select-all-count-keywords', {
                count: getTotalKeywords,
              })
            }}</span>
          </template>
        </div>
      </template>
    </template>

    <div v-if="!isSearch" :class="getFilterClasses">
      <div class="keyword_filters_item search-block">
        <search-keywords ref="searchKeywordBar" />
      </div>
      <div class="keyword_filters_item search-filter">
        <search-keywords-button @click="handleSearchButtonClick" />
        <filter-keywords v-if="!hideFilters" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { getFetchFilters } from '@/store/utils';

import { Events, EventBus } from '@/events';

import { exportAsTXT } from '@/helpers/downloads-service';

import RefreshMixin from '@/mixins/RefreshMixin';
import DashboardMixin from '@/mixins/DashboardMixin';
import ToolTipRenderMixin from '@/mixins/ToolTipRenderMixin';

import MangeTags from './components/ManageTags';
import ConfirmDeletingKeywords from 'components/modals/ConfirmDeletingKeywords';
import DuplicateKeywordsModal from 'components/main-table/DuplicateKeywordsModal';
import ConfirmDuplicateKeywords from 'components/modals/ConfirmDuplicateKeywords';
import FilterKeywords from '@/components/filters/FilterKeywords';
import SearchKeywords from '@/components/common/SearchKeywords';
import resize from 'vue-resize-directive';
import { detectIsSurferSEO } from '@/helpers';
import SearchKeywordsButton from 'components/filters/SearchKeywordsButton.vue';

export default {
  name: 'DashboardActionBar',
  components: {
    SearchKeywordsButton,
    'manage-tags': MangeTags,
    'filter-keywords': FilterKeywords,
    'search-keywords': SearchKeywords,
  },
  mixins: [DashboardMixin, RefreshMixin, ToolTipRenderMixin],
  directives: {
    resize,
  },
  props: {
    hideActionButtons: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isMobile: window.screen.width <= window.MOBILE_WIDTH_RESOLUTION_PHONE,
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.windowResizeHandler);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.windowResizeHandler);
  },
  computed: {
    ...mapGetters([
      'getViewkeyView',
      'keyKeywordsById',
      'getLazyLoadMode',
      'isViewOnlyUser',
      'getSelectedAuth',
      'getFavoriteData',
      'getSearchKeyword',
      'getOriginalItems',
      'getTotalKeywords',
      'getCurrentProject',
      'getDataForViewkey',
      'getIsRefreshRunning',
      'getAllWithoutIdsData',
      'getGlobalSearchQuery',
      'getIsAllCheckboxesSelected',
      'getCommonKeywordsChartIsShow',
      'getSelectedKeywordsWithAllData',
    ]),

    isSearch() {
      return this.$route.name === 'searchResults';
    },
    getFilterClasses() {
      return {
        keyword_filters_section: true,
        stick_right:
          (!this.isSelectAllVisible && !this.getIsAllCheckboxesSelected) ||
          !(!this.isSearch && !this.getLazyLoadMode && !this.isMobile),
      };
    },
    isDisable() {
      return !(this.getSelectedAuth.length || this.getIsAllCheckboxesSelected);
    },

    getStarsStatuses() {
      const starsStatuses = {
        addStartVisible: false,
        removeStartVisible: false,
      };

      if (!this.getIsAllCheckboxesSelected) {
        this.getSelectedKeywordsWithAllData.forEach((item) => {
          if (item.isfav) {
            starsStatuses.removeStartVisible = true;
          } else {
            starsStatuses.addStartVisible = true;
          }
        });
      } else {
        const { is_favored, is_unfavored } = this.getFavoriteData;
        if (is_favored === false) {
          starsStatuses.addStartVisible = true;
        }
        if (is_unfavored === false) {
          starsStatuses.removeStartVisible = true;
        }
      }

      return starsStatuses;
    },
    isSelectAllVisible() {
      return (
        this.getTotalKeywords !== this.getOriginalItems.length &&
        this.getSelectedAuth.length &&
        !this.getIsAllCheckboxesSelected
      );
    },
    isCurrentPageUnselected() {
      //used only when select all and withoutIds
      let dataCount = 0;
      this.getOriginalItems.forEach((item) => {
        if (this.getAllWithoutIdsData.find((item1) => item.id === item1)) {
          dataCount++;
        }
      });
      return dataCount === this.getOriginalItems.length;
    },
    isOnlyCurrentPageItemsSelected() {
      //used only when select all and withoutIds
      let dataCount = 0;
      this.getOriginalItems.forEach((item) => {
        if (this.getAllWithoutIdsData.find((item1) => item.id !== item1)) {
          dataCount++;
        }
      });
      return dataCount === this.getTotalKeywords - this.getAllWithoutIdsData.length;
    },
    hideFilters() {
      return detectIsSurferSEO();
    },
  },
  watch: {
    getIsAllCheckboxesSelected: {
      handler(isAll) {
        isAll ? this.fetchFavoriteData() : this.setFavoriteData({});
      },
    },
  },
  methods: {
    ...mapActions([
      'emitEdit',
      'setShownChart',
      'setFavoriteData',
      'resetAllKeywords',
      'fetchFavoriteData',
      'resetAllWithoutIds',
      'setSelectedKeywords',
      'toggleKeywordsFavorite',
      'setAllCheckboxesSelected',
      'toggleCommonKeywordsChartIsShow',
    ]),

    windowResizeHandler() {
      this.isMobile = window.screen.width <= window.MOBILE_WIDTH_RESOLUTION_PHONE;
    },
    // the icon type can be only 'set-fav' or 'remove-fav'
    getFavoriteTooltip(event, iconType) {
      const tooltipTextKey = this.isSearch
        ? 'footer-action-restricted-on-search'
        : iconType === 'set-fav'
          ? 'fav-kw-s'
          : 'unfav-kw-s';
      return this.getTooltip(event, tooltipTextKey);
    },

    getChartTooltip(event) {
      const tooltipText = this.isSearch
        ? this.$t('footer-action-restricted-on-search')
        : `${this.$t(this.getCommonKeywordsChartIsShow ? 'hide' : 'show')} ${this.$t('charts')}`;
      return this.getTooltip(event, null, tooltipText);
    },

    //  pass either the key of the text or the text to show
    getTooltip(event, tooltipTextKey, tooltipText = null, maxWidth = null) {
      const text = tooltipText || this.$t(tooltipTextKey);
      return this.tooltip({ text, event, maxWidth });
    },
    getCurrentPageCheckedItems() {
      const pageItems = this.getOriginalItems;
      const selectedKeywords = this.getSelectedAuth;
      const filteredData = pageItems.filter((item) => {
        return selectedKeywords.find((selectedItem) => {
          return item.id === selectedItem;
        });
      });
      return filteredData;
    },
    emitMove() {
      EventBus.emit(Events.SET_KEYWORDS_TO_MOVE, {
        keywordAuth: this.getSelectedAuth[0],
        multiple: this.getSelectedAuth.length > 1,
      });
    },
    openDeleteKeywordsModal() {
      this.$modal.show(
        ConfirmDeletingKeywords,
        {
          keywords: this.getSelectedKeywordsWithAllData,
          isAllSelected: this.getIsAllCheckboxesSelected,
        },
        {
          classes: 'v--modal center-modal-popup',
          clickToClose: window.screen.width > window.MOBILE_WIDTH_RESOLUTION_PHONE,
          height: 'auto',
          name: 'ConfirmDeletingKeywords',
          pivotX: 0,
          width: 282,
        },
      );
    },

    async addToFavorite() {
      try {
        await this.toggleKeywordsFavorite({
          keywords: this.getSelectedAuth,
          action: true,
        });
        this.resetAllKeywords();
        this.$toastr.s(this.$t('success-keywords-were-added-to-favorites'));
      } catch (error) {
        this.$toastr.e(error);
      }
    },
    async removeFromFavorite() {
      try {
        await this.toggleKeywordsFavorite({
          keywords: this.getSelectedAuth,
          action: false,
        });
        this.resetAllKeywords();
        this.$toastr.s(this.$t('success-keywords-were-removed-from-favorites'));
      } catch (error) {
        this.$toastr.e(error);
      }
    },
    toggleCommonKeywordsCharts() {
      const checkedItems = this.getSelectedAuth;
      if (
        !this.getCommonKeywordsChartIsShow &&
        (checkedItems.length > 10 ||
          (this.getIsAllCheckboxesSelected && this.getTotalKeywords > 10 && !this.getCommonKeywordsChartIsShow))
      ) {
        this.$toastr.w(this.$t('keyword-chart-limitation'));
      } else {
        this.setShownChart({ keyword: null, project: null });
        this.toggleCommonKeywordsChartIsShow();

        EventBus.emit(Events.OPEN_HISTORICAL_CHART, checkedItems);
      }
    },
    exportSelectedAsTXT() {
      let params = {};
      if (!this.getViewkeyView) {
        params = this.getCurrentProject || { id: 'file' };
      } else {
        params = {
          auth: this.$route.params.auth,
          shortkey: this.$route.params.viewkey,
          password: this.getDataForViewkey.password,
          id: this.subproject || this.project,
        };
      }
      let queryParams = getFetchFilters(this.$store.getters);
      if (!this.getIsAllCheckboxesSelected) {
        const paramObj = {};
        this.getSelectedKeywordsWithAllData.forEach((item, index) => {
          paramObj[`keywordIds[${index}]`] = item.id;
        });
        queryParams = { ...queryParams, ...paramObj };
      }
      exportAsTXT(params, queryParams, this.getViewkeyView);
    },
    duplicateKeywords() {
      if (this.getIsAllCheckboxesSelected) {
        const selectedItemsLength = this.getTotalKeywords - this.getAllWithoutIdsData.length;
        this.$modal.show(
          ConfirmDuplicateKeywords,
          {
            totalKeywords: selectedItemsLength,
            handler: async () => {
              this.handleDuplicateKeywordsModal();
            },
          },
          {
            width: 350,
            height: 'auto',
            classes: 'v--modal',
          },
        );
      } else {
        this.handleDuplicateKeywordsModal();
      }
    },
    handleDuplicateKeywordsModal() {
      this.$modal.show(
        DuplicateKeywordsModal,
        {},
        {
          classes: 'v--modal center-modal-popup modal-for-mobile',
          clickToClose: window.screen.width > window.MOBILE_WIDTH_RESOLUTION_PHONE,
          height: 'auto',
          name: 'DuplicateKeywordsModal',
          pivotX: 0,
          width: 649,
        },
      );
    },
    handleSelectAll() {
      if (!this.getIsAllCheckboxesSelected) {
        this.setAllCheckboxesSelected(true);
      }
      if (this.getAllWithoutIdsData.length) {
        this.resetAllWithoutIds();
      }
    },
    handleUnSelectAll() {
      this.setAllCheckboxesSelected(false);
      this.setSelectedKeywords([]);
    },
    handleSearchButtonClick() {
      this.$refs.searchKeywordBar.handleSearchButtonClick();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~sass/partials/action-bar';

.dashboard-action-bar {
  align-items: center;
  color: kw-color(kw-white, 1);
  display: flex;
  padding: 8px 0;
  margin-bottom: 8px;

  button {
    height: auto;

    &.button-action-bar {
      ::v-deep .kw {
        color: kw-color(kw-blue, 1);
        font-size: 15px;
        font-weight: 700;

        &.kw-tag {
          transform: rotate(0deg);
        }
      }

      div {
        ::v-deep .button-loader {
          position: static;
          height: 15px !important;
          min-width: 14px !important;
          width: 14px !important;
        }
      }
    }
  }

  ::v-deep .dropdown_container {
    button {
      .kw {
        color: kw-color(kw-blue, 1);
        font-weight: 700;
        transform: rotate(0deg);
      }
    }
  }

  &.dashboard-action-bar-fixed {
    position: sticky;
    background: kw-color(kw-white, 1);
    top: 177px;
    z-index: 15;
    padding: 0 10px;

    @media (max-width: 959px) {
      top: 114px;

      &.with_action_bar {
        top: 223px;
      }
    }
  }

  .select_all_block {
    background: #e5ecf3;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 26px;
    border-radius: 5px;
    margin: 0;
    color: black;

    span {
      display: inline-block;
      margin: 0 0 0 4px;
      font-size: 14px;
      font-weight: 500;
      color: rgba($color: #4180c6, $alpha: 1);
      cursor: pointer;
      transition: color 0.5s;

      &:hover {
        color: rgba($color: #4180c6, $alpha: 0.7);
      }
    }

    @media (max-width: 565px) {
      flex-direction: column;
      height: fit-content;
    }
    @media (max-width: 420px) {
      flex-direction: row;
      padding: 5px 10px;
      height: auto;
      font-size: 13px;
      line-height: 14px;
    }
  }

  .keyword_filters_section {
    margin-left: auto;
    display: flex;
    color: black;

    .keyword_filters_item {
      margin-left: 10px;
      background: white;

      &.search-block {
        height: 37px;

        .keyword-search-input-wrap {
          height: 100%;

          .search_input_icon {
            .kw-search {
              top: 17px;
            }
          }

          .top-bar__input-search {
            height: 34px;
          }
        }
      }
    }

    @media (max-width: 600px) {
      margin-bottom: 0;

      .keyword_filters_item {
        margin-left: 0;
      }
    }
  }
}

.action-bar__button-project {
  align-items: center;
  color: kw-color(kw-white, 1);
  display: flex;
  flex-flow: row nowrap;
  position: relative;
}

.action-bar__button-project_left {
  flex: 1 0 auto;
}

.action-bar__button-project_central {
  flex: 3 0 auto;
  justify-content: center;
}

.action-bar__button-project_right {
  flex: 2 0 auto;
  justify-content: flex-end;
}

.action-bar__description {
  color: kw-color(kw-white, 1);
  cursor: default;
  font-size: 14px;
  padding: 0 24px;
}

.action-bar__dropdown {
  position: relative;
}

.button-action-bar {
  &:disabled {
    opacity: 0.6;
  }
}

::v-deep .button-loader {
  margin: 0;
}

.manage_tags_body {
  width: 270px;
  background: kw-color(kw-white, 1);
  box-shadow: 0px 20px 45px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.search-filter {
  display: flex;
  gap: 8px;
  align-items: center;
  background: none !important;
}
</style>
